import Navbar from "../../components/Navbar";
import TrailoredImg from '../../assets/images/products/tailored.svg'
import Email from '../../assets/images/icon/Email.png'
import Footer from "../../components/Footer";

const Contact = () => {
  return (
    <>
    <div className="contactPage">
        <Navbar/>
        <div className="conatctSection">
            <div className="container">
                <div className="seePranActionRow">
                    <div className="seePranActionLeftColum">
                        <h3>Contact us</h3>
                        <p>Have questions about Pran.AI? We're here to help you transform your healthcare operations.</p>
                        <div className="contactCard">
                            <div className="seepranImg"><img src={Email} alt="Email" /></div>
                            <div className="seepranContent">
                                <h4>contact@pran.ai</h4>
                                <p>contact@pran.ai</p>   
                            </div>
                        </div>
                    </div>
                    <div className="contactRightColum">
                        <div className="contactForm">
                            <div className="schduleWalkHeader">
                                <h4>Get in touch</h4>
                            </div>
                            <div className="schduleFormSection">
                                <form>
                                    <div className="row">
                                        <div className="col-xs-12 col-md-6">
                                            <div className="formGroup">
                                                <input type="text" placeholder="First Name " />  
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-6">
                                            <div className="formGroup">
                                                <input type="text" placeholder="Last Name " />  
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-12">
                                            <div className="formGroup">
                                                <input type="text" placeholder="Your email" />  
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-12">
                                            <div className="formGroup">
                                                <input type="text" placeholder="Phone Number" />  
                                            </div>
                                        </div>
                                        
                                        <div className="col-xs-12 col-md-12">
                                            <div className="formGroup mb-2">
                                                <h6>Interest Module</h6>
                                                <div className="checkBoxModuleMain">
                                                    <div className="checkBoxModule">
                                                        <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike"/>
                                                        <label for="vehicle1"> Govt Dashboard</label>
                                                    </div>
                                                    <div className="checkBoxModule">
                                                        <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike"/>
                                                        <label for="vehicle1"> Patients App</label>
                                                    </div>
                                                    <div className="checkBoxModule">
                                                        <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike"/>
                                                        <label for="vehicle1"> HMIS / LIMS</label>
                                                    </div>
                                                    <div className="checkBoxModule">
                                                        <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike"/>
                                                        <label for="vehicle1"> PHR</label>
                                                    </div>
                                                    <div className="checkBoxModule">
                                                        <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike"/>
                                                        <label for="vehicle1"> Hospital Business</label>
                                                    </div>
                                                    <div className="checkBoxModule">
                                                        <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike"/>
                                                        <label for="vehicle1"> AI Chatbot</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-12">
                                            <div className="formGroup">
                                                <h6>Anything specific you would like to see? </h6>
                                                <textarea placeholder="Additional Message" rows="4"></textarea>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-12">
                                            <div className="formGroup">
                                                <button type="submit" className="submitBtn">Submit</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="faqSection">
            <div className="container">
                <h4>Faq</h4>
                <div className="faqQuesAns">
                    <ol>
                        <li>What is Pran AI and how does it help healthcare & government organisations?</li>
                        <li>What products are included in the Pran AI suite?</li>
                        <li>Is Pran AI compliant with national healthcare standards like NDHM/ABDM?</li>
                        <li>How does Pran AI ensure data security and privacy?</li>
                        <li>Can Pran AI integrate with existing hospital software or government systems?</li>
                        <li>How does the AI engine work inside Pran AI?</li>
                        <li>Is Pran AI customizable for different types of hospitals or government institutions?</li>
                        <li>What kind of support and onboarding does Pran AI provide?</li>
                        <li>Does Pran AI support mobile access for patients and doctors?</li>
                        <li>How can my organisation start using Pran AI?</li>
                    </ol>
                </div>
            </div>
        </div>
    </div>
    <Footer />
    </>
    );  
};

export default Contact;